import { render, staticRenderFns } from "./MemberProjectsPage.vue?vue&type=template&id=544c710a&scoped=true&"
import script from "./MemberProjectsPage.vue?vue&type=script&lang=js&"
export * from "./MemberProjectsPage.vue?vue&type=script&lang=js&"
import style0 from "./MemberProjectsPage.vue?vue&type=style&index=0&id=544c710a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544c710a",
  null
  
)

export default component.exports